import { inject } from 'mobx-react';
import * as React from 'react';

import { ServerDrivenUiStore } from './sdui-store';

import { traverseChildren } from './utils';

import { SduiContent } from './sdui-content';

interface SduiComposerProps {
  sdui?: ServerDrivenUiStore;
  name: string;
}

@inject('sdui')
export class SduiComposer extends React.Component<SduiComposerProps> {
  private contentCollection: { [key: string]: any } = {};

  public constructor(props) {
    super(props);
    this.getContent = this.getContent.bind(this);
  }

  private scanChildren() {
    const { sdui } = this.props;
    if (sdui) {
      traverseChildren(this, child => {
        if (child && child.type === SduiContent) {
          if (child.props.local) {
            this.contentCollection[child.props.name] = child.props.children;
          } else {
            sdui.declareContent(child.props.name, child.props.children);
          }

          return true;
        }

        return false;
      });
    }
  }

  public render() {
    const { sdui, name } = this.props;

    if (!sdui) {
      return this.props.children;
    }

    const { layout, hierarchy, options } = sdui.getConfig(name);

    if (layout && hierarchy) {
      this.scanChildren();
      const result = layout.generate(hierarchy, this.getContent, options);

      if (result !== false) {
        return result;
      }
    }

    return this.props.children;
  }

  private getContent(name) {
    const { sdui } = this.props;
    //SDUI Store null checking is handled in render method, which is the only place this is called.

    //Default to checking the local collection first, then check global
    const content = this.contentCollection[name] || sdui.getContent(name);

    return content;
  }
}
